/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable productions
import { tableSchemaBase as columns } from '../productions.columns';
import { tableSchemaBase as columnsForPartner } from '../productionsForPartner.columns';
import { tableSchemaBase as columnsForProducer } from '../productionsForProducer.columns';
import { tableSchemaBase as columnsWithoutContact } from '../productionsWithContact.columns';
import { tableSchemaBase as columnsWithoutOrganization } from '../productionsWithoutOrganization.columns';
import { tableSchemaBase as columnsWithoutProducer } from '../productionsWithoutProducer.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IProductionsDatatableSlice {
	productionsDatatableOptions: TColumnsSchema[];
	setProductionsDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) => void;

	productionsWithoutContactDatatableOptions: TColumnsSchema[];
	setProductionsWithoutContactDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) => void;

	productionsWithoutOrganizationDatatableOptions: TColumnsSchema[];
	setProductionsWithoutOrganizationDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) => void;

	productionsWithoutProducerDatatableOptions: TColumnsSchema[];
	setProductionsWithoutProducerDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) => void;

	productionsForPartnerDatatableOptions: TColumnsSchema[];
	setProductionsForPartnerDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) => void;

	productionsForProducerDatatableOptions: TColumnsSchema[];
	setProductionsForProducerDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeProductionsDatatableSlice = (
	s: any
): any => ({
	productionsDatatableOptions:
		s.productionsDatatableOptions,
	productionsWithoutContactDatatableOptions:
		s.productionsWithoutContactDatatableOptions,
	productionsWithoutOrganizationDatatableOptions:
		s.productionsWithoutOrganizationDatatableOptions,
	productionsWithoutProducerDatatableOptions:
		s.productionsWithoutProducerDatatableOptions,
	productionsForPartnerDatatableOptions:
		s.productionsForPartnerDatatableOptions,
	productionsForProducerDatatableOptions:
		s.productionsForProducerDatatableOptions,
});

const initialState = {
	productionsDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
	productionsWithoutContactDatatableOptions:
		columnsWithoutContact.filter(
			(item) => item.defaultVisible
		),
	productionsWithoutOrganizationDatatableOptions:
		columnsWithoutOrganization.filter(
			(item) => item.defaultVisible
		),
	productionsWithoutProducerDatatableOptions:
		columnsWithoutProducer.filter(
			(item) => item.defaultVisible
		),
	productionsForPartnerDatatableOptions:
		columnsForPartner.filter(
			(item) => item.defaultVisible
		),
	productionsForProducerDatatableOptions:
		columnsForProducer.filter(
			(item) => item.defaultVisible
		),
};

export const createProductionsDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IProductionsDatatableSlice
> = (set) => ({
	...initialState,

	setProductionsDatatableOptions: (
		options: TColumnsSchema[]
	) => set({ productionsDatatableOptions: options }),

	setProductionsWithoutContactDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			productionsWithoutContactDatatableOptions: options,
		}),

	setProductionsWithoutOrganizationDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			productionsWithoutOrganizationDatatableOptions:
				options,
		}),

	setProductionsWithoutProducerDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			productionsWithoutProducerDatatableOptions: options,
		}),

	setProductionsForPartnerDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			productionsForPartnerDatatableOptions: options,
		}),

	setProductionsForProducerDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			productionsForProducerDatatableOptions: options,
		}),
});
